<template>
  <div class="ani-stage-progress">
    <div class="inner">
      <vux-progress
        :percent="percent"
        :show-cancel="false"
      />

      <span class="no">
        <small><strong>{{ current }}</strong> / {{ total }}</small>
      </span>
    </div>
  </div>
</template>

<script>
  import VuxProgress from 'vux/src/components/x-progress'

  export default {
    name: 'AniStateProgress',

    props: {
      total: {
        type: Number
      },

      current: {
        type: Number
      }
    },

    computed: {
      percent () {
        return ((!this.total || this.current <= 0) ? 0 : ((this.current) / this.total).toFixed(2)) * 100
      },

      step () {
        const c = (this.current + 1)
        const t = this.total || 0
        return c <= 0 ? 1 : (c >= t ? t : c)
      }
    },

    components: {
      VuxProgress
    }
  }
</script>

<style lang="scss">
  .ani-stage-progress {
    > .inner {
      width: 50%;
      position: relative;
      top: 2px;
      left: -40px;

      > .no {
        position: absolute;
        top: -6px;
        right: -32px;
        color: #636363;
        font-size: 11px;
        background-color: rgba(255, 255, 255, 0.66);
        border-radius: 10px;
        padding: 0 6px;
        line-height: 1.5em;
        /*box-shadow: 1px 0 5px #dddddd;*/

        strong {
          font-weight: normal;
          font-size: 11.5px;
          color: #272727;
        }
      }
    }

    .weui-progress {
      display: none;
    }

    $size: 3px;

    .weui-progress__inner-bar {
      transition: width .25s;
      overflow: hidden;
      border-radius: $size;
      height: $size;
    }

    .weui-progress__bar {
      background-color: #d5d5d5;
      border-radius: $size;
      height: $size;
    }
  }
</style>
